import { Injectable } from "@angular/core";
import { PmsAppointmentTypeDto } from "../interfaces/dto/pms-appointment-types.dto";
import { PmsAppointmentType } from "../interfaces/pms-appointment-types.interface";

@Injectable({
  providedIn: 'root'
})
export class PmsAppointmentTypesAdapter {
  run(appointmentType: PmsAppointmentTypeDto): PmsAppointmentType {
    return {
      ...appointmentType
    };
  }
}